import { stockTabs } from "./components/stockTabs.js";
import { reviewsSwiper } from "./components/reviewsSwiper.js";
import { reviewsVideo } from "./components/reviewsVideo.js";
import { mastersMobile } from "./components/mastersMobile.js";
import { stockTabsAnchors } from "./components/stockTabsAnchors.js";

window.addEventListener('DOMContentLoaded', () => {
  stockTabs();
  reviewsSwiper();
  reviewsVideo();
  mastersMobile();
  stockTabsAnchors();
});
